
import { component } from '@/helpers/vueTyped';
import { Summary } from '@/api/validators/content';
import { config } from '@/config';
import { elapsedTime } from '@/helpers/utils';
import HighlightSectionGhostLoader from './HighlightSectionGhostLoader.vue';

interface HighlightSectionProps {
  summary?: Summary;
}

export default component<HighlightSectionProps>()({
  name: 'HighlightSection',

  props: {
    summary: {},
  },

  computed: {
    elapsedTime(): string {
      return elapsedTime(this.summary!.publishedDate);
    },

    entityTagsWithImage(): Summary['cat']['entityTags'] {
      return this.summary!.cat.entityTags.filter((eT) => eT.image != null);
    },

    entityIconURL(): string {
      const primary = this.entityTagsWithImage.find((eT) => eT.isPrimary);
      if (primary) {
        return `${config.cdn}${primary.image}`;
      }
      const lastEntity = this.entityTagsWithImage[this.entityTagsWithImage.length - 1];
      return lastEntity.image!;
    },

    primaryCategory(): string {
      return this.summary!.cat.entityTags.find((eT) => eT.isPrimary)!.name!;
    },
  },

  render() {
    if (!this.summary) {
      return (
        <HighlightSectionGhostLoader />
      );
    }

    return (
      <div class='highlight-section-container'>
        <div class='category-logo-container'>
          {this.entityIconURL && (
            <img
              class='category-logo'
              src={`${this.entityIconURL}?width=150`}
              alt=''
            />
          )}
          <div class='category-name'>{this.primaryCategory}</div>
        </div>
        <div class='item-name'>{this.summary.title}</div>
        <div class='item-date'>{this.elapsedTime}</div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2defe060/HighlightSection.vue" });